<script lang="ts" setup>

	const $props = withDefaults(defineProps<{
		as?: string
		clickable?: boolean
		to?: object|string
		dense?: boolean
	}>(), { as: 'div', dense: false})

	const NuxtLink = resolveComponent('NuxtLink')

	const as = $props.to ? NuxtLink : $props.as

	provide('dense', $props.dense)
</script>

<template>
	<component
		:is="as"
		class="gs-item px-3"
		:class="{'cursor-pointer' : clickable, 'py-2 text-sm': dense, 'py-3': !dense }"
		v-bind="to ? {noPrefetch: true, to} : {}"
	>
		<slot />
	</component>
</template>

<style scoped>
.gs-item {
	@apply relative flex flex-nowrap transition-[color,background-color] duration-300 items-center w-full;
	min-height: 48px;
}
</style>
